<template>
  <el-form ref="form" label-width="120px" :model="pointInfo" v-loading="loading">
    <div class="text-right mb-10px" v-show="showFlow">
      <el-button size="small" @click.stop="$refs.flowDetails.showDialog = true">查看进度</el-button>
    </div>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="设备设施名称" prop="name">
          <el-input
            v-model="pointInfo.name"
            placeholder="请输入设备设施名称"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="设备设施编号" prop="no">
          <el-input
            v-model="pointInfo.no"
            placeholder="请输入设备设施编号"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="危险介质" prop="hazardousMedia">
          <el-input
            v-model="pointInfo.hazardousMedia"
            placeholder="请输入危险介质"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="所属区域" prop="areaText">
          <el-input
            v-model="pointInfo.areaText"
            placeholder="请输入所属区域"
            maxlength="50"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="所属单位" prop="ownedUnit">
          <el-input
            v-model="pointInfo.ownedUnit"
            placeholder="请输入所属单位"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="kks编码" prop="kksNo">
          <el-input
            v-model="pointInfo.kksNo"
            placeholder="请输入kks编码"
            maxlength="50"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="设备类别" prop="typeText">
          <el-input
            v-model="pointInfo.typeText"
            placeholder="请输入设备类别"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="是否特种设备" prop="isSpecial">
          <el-select
            v-model="pointInfo.isSpecial"
            placeholder="请选择是否属于特种设备"
            class="w-full"
            clearable
            filterable
            :disabled="disabled"
          >
            <el-option
              v-for="item in deviceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <FlowDetails :taskId="taskId" ref="flowDetails" />
  </el-form>
</template>

<script>
import { EquipmentFacilitySourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import FlowDetails from './FlowDetails'

const equipmentFacilitySourcesDangerIdentifyApi = new EquipmentFacilitySourcesDangerIdentifyApi()

export default {
  name: 'business-equip-form',
  components: {
    FlowDetails,
  },
  props: {
    taskId: {
      type: String,
      default: null,
    },
    showFlow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      pointInfo: {
        areaText: '',
        hazardousMedia: '',
        isSpecial: '',
        name: '',
        ownedUnit: '',
        typeText: '',
        kksNo: '',
      },
      deviceList: [
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        },
      ],
      disabled: true,
    }
  },
  methods: {
    async getPointInfo() {
      this.loading = true
      const [err, res] = await equipmentFacilitySourcesDangerIdentifyApi.getEquipmentFacilityInfo(
        this.taskId
      )
      if (!err) {
        const { creationTime, ...otherData } = res
        this.pointInfo = {
          ...otherData,
        }
      }
      this.loading = false
    },
  },
  created() {
    if (this.taskId) {
      // 获取风险点基本信息
      this.getPointInfo()
    }
  },
}
</script>

<style lang="scss" scoped></style>
